import { API_SERVER_URL } from '../shared/config/constants';
import { Observable } from 'rxjs';
import { getIdTokenFromLocalStorage } from "./DataService";

// Customers are served exclusively via the backend REST API (PostgreSQL-backed,
// via CustomerRepository). There is no Firestore fallback/onSnapshot path for
// Customers in React - the backend owns any temporary Firestore compatibility
// on its own side. Mirrors ProductDataService.ts.

export const getFailedSyncCustomersFromServer = (
  userId: string,
  connector: string,
  limit: number,
  sortField: string,
  sortOrder: number,
  firstVisibleId?: string,
  lastVisibleId?: string,
  mode?: string,
  filters?: { key: string; value: any; }[]
): Observable<{
  customers: any[];
  firstDocId: string;
  lastDocId: string;
  total?: number;
}> => {
  return new Observable(subscriber => {
    const processRequest = async () => {
      try {
        const idToken = await getIdTokenFromLocalStorage();
        const requestData = {
          userId,
          connector,
          limit,
          sortField,
          sortOrder,
          firstVisibleId,
          lastVisibleId,
          mode,
          filters: filters ? JSON.parse(JSON.stringify(filters)) : []
        };

        const response = await fetch(`${API_SERVER_URL}/customers/failed`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${idToken}`
          },
          body: JSON.stringify(requestData)
        });

        if (!response?.ok) {
          const error = await response?.json();
          console.error('Error in getFailedSyncCustomersFromServer:', error);
          throw new Error('Failed to fetch failed customers');
        }

        const data = await response?.json();
        const firstDocId = data?.firstDocId ? data?.firstDocId : null;
        const lastDocId = data?.lastDocId ? data?.lastDocId : null;
        subscriber.next({
          customers: data?.customers ?? [],
          firstDocId,
          lastDocId,
          total: data?.total
        });
        subscriber?.complete();

      } catch (error: any) {
        console.error('Error in getFailedSyncCustomersFromServer:', error);
        subscriber?.error(error);
      }
    };

    processRequest();
  });
};

export const getSuccessSyncCustomersFromServer = (
  userId: string,
  connector: string,
  limit: number,
  sortField: string,
  sortOrder: number,
  firstVisibleId?: string,
  lastVisibleId?: string,
  mode?: string,
  query?: { key: string; value: any; }[]
): Observable<{
  customers: any[];
  firstDocId: string;
  lastDocId: string;
  total?: number;
}> => {
  return new Observable(subscriber => {
    const processRequest = async () => {
      try {
        const idToken = await getIdTokenFromLocalStorage();
        const requestData = {
          userId,
          connector,
          limit,
          sortField,
          sortOrder,
          firstVisibleId,
          lastVisibleId,
          mode,
          query: query ? JSON.parse(JSON.stringify(query)) : []
        };

        const response = await fetch(`${API_SERVER_URL}/customers/success`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `${idToken}`
          },
          body: JSON.stringify(requestData)
        });

        if (!response?.ok) {
          const error = await response?.json();
          console.error('Error in getSuccessSyncCustomersFromServer:', error);
          throw new Error('Failed to fetch customers');
        }

        const data = await response?.json();
        const firstDocId = data?.firstDocId ? data?.firstDocId : null;
        const lastDocId = data?.lastDocId ? data?.lastDocId : null;
        subscriber.next({
          customers: data?.customers ?? [],
          firstDocId,
          lastDocId,
          total: data?.total
        });
        subscriber?.complete();

      } catch (error: any) {
        console.error('Error in getSuccessSyncCustomersFromServer:', error);
        subscriber?.error(error);
      }
    };

    processRequest();
  });
};
